import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "jyzk-app"
};
const _hoisted_2 = {
  class: "screen-stage"
};
import { useResize } from "@/hooks/scale-resize/index.js";
export default {
  __name: 'App',
  setup(__props) {
    const {
      screenRef
    } = useResize();
    return (_ctx, _cache) => {
      const _component_RouterView = _resolveComponent("RouterView");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        ref_key: "screenRef",
        ref: screenRef,
        class: "large-screen-wrap"
      }, [_createVNode(_component_RouterView)], 512)])]);
    };
  }
};